const FEATURE_FLAGS = {
  GOOGLE_SIGN_IN: 'GOOGLE_SIGN_IN',
  FIVE_GARMENTS_DISCOUNT_ZERO: 'FIVE_GARMENTS_DISCOUNT_ZERO',
  SURVEY_HDYMU: 'SURVEY_HDYMU',
  SALES_PILL: 'SALES_PILL',
  SALES_BANNER: 'SALES_BANNER',
  SALES_NOTIFICATION: 'SALES_NOTIFICATION',
  SALES_CATEGORIES_BANNER: 'SALES_CATEGORIES_BANNER',
  DISABLE_FB_LOGIN: 'DISABLE_FB_LOGIN',
  DISABLE_IN_APP_BROWSER_BANNER: 'DISABLE_IN_APP_BROWSER_BANNER',
} as const;

export {FEATURE_FLAGS};
